import router from '@/router';

export default function goBack(): void {
  router.push({ name: 'Onboarding' });
}
